module.exports = __webpack_public_path__ + "img/5_21.06.02_Series96_AnnixHomes_R4_01.06eb74ec.jpg";